import { Box, Button } from '@mui/material';
import { useContext, useState } from 'react';
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
	return (
		<Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
			<Box fontSize="14px" fontWeight="600">{step.title}</Box>
			<Box fontSize="12px" py="4px">{step.content}</Box>
			<Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
				<Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
					Got it!
				</Button>
			</Box>
		</Box>
	);
};

const steps = [
	{
		target: '.fifteenth-step',
		title: 'Your Collection',
		content: `Everything you've saved, just a click away.`,
		placement: 'right',
		disableBeacon: true,
		disableScrollParentFix: true,
		disableScrolling: true,
	},
];


export const Save = () => {
	const { tool_state, personalization_state } = useContext(ToolContext);
	const { __SESSION } = tool_state;
	const { walkthrough } = personalization_state
	
	const [stepIndex, setStepIndex] = useState(0);

	const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
	const tool_id =  process.env.REACT_APP_TID_PSL;

	const handleJoyrideCallback = async (data) => {
		const { status, action, index, type } = data;
		
		let body = {
			user_id: user_id,
			tool_id: tool_id,
			feature_name: 'save',
			personalization:[{sf_name: 'save' , status: 1}]
		}

		if (type === 'step:after' && action === 'next') {
			setStepIndex(index + 1);
		}

		if (status === "finished") {
			const res = await rqx.post(`<<global>>/${env()}/personalization/create`, body)
			if (res.msg === 'success') {
				walkthrough.set(prev => ({...prev, save: false}))
			}
		}
		
		if (['close', 'stop'].includes(action)) {
			walkthrough.set(prev => ({...prev, save: false}))
			setStepIndex(0);
			await rqx.post(`<<global>>/${env()}/personalization/create`, body)
		}
	};		

	return (
			<Joyride
				continuous
				disableOverlayClose={true}
				run={walkthrough.data.save}
				steps={steps}
				stepIndex={stepIndex}
				showSkipButton={true}
				callback={handleJoyrideCallback}
				tooltipComponent={CustomComponent}
			/>
	);
};
